/**
 * API 설정 파일
 * 환경 변수에서 API Base URL을 읽어옵니다.
 *
 * 환경 변수 우선순위:
 * 1. .env.local (로컬 개발용, 최우선)
 * 2. .env.[mode] (예: .env.dev, .env.dev-ec2, .env.prd)
 * 3. .env (기본값)
 */

const getApiBaseUrl = (): string => {
  const baseUrl = import.meta.env.VITE_API_BASE_URL;

  if (baseUrl) {
    return baseUrl;
  }

  console.warn('VITE_API_BASE_URL이 설정되지 않았습니다. 기본값을 사용합니다.');
  return 'http://dev.exceedplatform.com:8082';
};

export const API_BASE_URL = getApiBaseUrl();
export { getApiBaseUrl };

export const getApiUrl = (endpoint: string): string => {
  if (endpoint.startsWith('http://') || endpoint.startsWith('https://')) {
    return endpoint;
  }

  const normalizedEndpoint = endpoint.startsWith('/') ? endpoint : `/${endpoint}`;
  const normalizedBaseUrl = API_BASE_URL.endsWith('/')
    ? API_BASE_URL.slice(0, -1)
    : API_BASE_URL;

  return `${normalizedBaseUrl}${normalizedEndpoint}`;
};

export const getApiV1Url = (endpoint: string): string => {
  return getApiUrl(`/api/v1${endpoint.startsWith('/') ? endpoint : `/${endpoint}`}`);
};

export const isDevelopment = import.meta.env.DEV;
export const isProduction = import.meta.env.PROD;

if (isDevelopment) {
  console.log('API 설정:', {
    baseUrl: API_BASE_URL,
    mode: import.meta.env.MODE,
    isDev: isDevelopment,
    isProd: isProduction
  });
}
